import { render, staticRenderFns } from "./PreviewNotification.vue?vue&type=template&id=6a2ff9d3&"
import script from "./PreviewNotification.vue?vue&type=script&lang=js&"
export * from "./PreviewNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports